<template>
  <div class="container">
    <content-header :data="[{text:'试题一览', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
          <router-link to="/question/new">
            <el-button type="primary" icon="plus">添加</el-button>
          </router-link>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="请输入名称关键字"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-entry">
          <el-select v-model="type" clearable value-key="id" placeholder="请选择题型" @change="searchHandle">
            <el-option
              v-for="item in typeIds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="search-entry">
          <el-select v-model="categoryId" clearable value-key="id" placeholder="请选择分类" @change="searchHandle">
            <el-option
              v-for="item in categoryIds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            label="题型"
            fixed>
            <template slot-scope="scope">
            <span>{{scope.row.type===1?'单选题':'多选题'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="试题摘要"
            width="200"
            >
            <template slot-scope="scope">
              <div>{{scope.row.question}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="category_name"
            label="试题分类">
          </el-table-column>
          <el-table-column
            prop="created"
            label="创建时间"
            width="180">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="200">
            <template slot-scope="scope">
              <!--el-button @click="downloadHandle(scope)" type="text" size="small" >查看</el-button-->
              <el-button @click="initEditHandle(scope)" type="text" size="small" >修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > pageSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 新建弹出区域 -->
      <div class="new-wrap">
        <el-dialog :title="curObj.id ? '修改红包' : '添加红包'" :visible.sync="isObjShow">
          <el-form :model="curObj" :rules="curObjRules" ref="curObjForm" label-position="right" label-width="0px">
            <el-form-item prop="name" label="品牌名称" :label-width="formLabelWidth">
              <el-input name="name" v-model="curObj.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="logo" label="LOGO" :label-width="formLabelWidth">
              <el-upload
                class="avatar-uploader"
                action="//upload-z2.qiniup.com"
                :data="uploadForm"
                :show-file-list="false"
                :on-success="uploadPhotoSuccess"
                :before-upload="beforePhotoUpload"
                :on-error="uploadError">
                <img v-if="curObj.logo" :src="domainPic + curObj.logo" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item prop="description" label="描述" :label-width="formLabelWidth">
              <ky-editor v-model="curObj.description"
                ref="myQuillEditor">
              </ky-editor>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isObjShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import date from 'utils/date'
  import QuestionModel from 'models/question'
  import CommonModel from 'models/common'
  import KyEditor from 'components/KyEditor'

  export default {
    components: {
      KyEditor,
    },
    data () {
      return {
        domainPic: constants.basic.domain_pic,
        keywords: '',
        tableData: [],
        isObjShow: false,
        curObj: {
          id: '',
          name: '',
          image: '',
        },
        formLabelWidth: '80px',
        curObjRules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
        },
        curPage: 1,
        pageSize: 10,
        total: 0,
        //
        uploadForm: {key: '', token: ''},
        qiniuHost: '',
        //
        categoryId: '',
        categoryIds: [],
        type: '',
        typeIds: [{id: '1', name: '单选题'}, {id: '2', name: '多选题'}],
        startDate: '',
        endDate: '',
        dateRange: '',
        datePickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
      }
    },
    created () {
      QuestionModel.findCategory({curPage: 1, pageSize: 1000}).then(res => {
        this.categoryIds = res.item_list
      })
      this.getObjList()
    },
    methods: {
      //
      uploadRemove (file, fileList) {
        console.log(file)
      },
      uploadError (err, file, fileList) {
        console.log(err)
      },
      uploadExceed (files, fileList) {
        console.log(files.length)
      },
      uploadPhotoSuccess (response, file, fileList) {
        // console.log(response)
        this.curObj.logo = response.key
      },
      beforePhotoUpload (file) {
        const isPic = (file.type === 'image/jpeg' || file.type === 'image/png')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isPic) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
          return false
        }
        //
        if (!this.uploadForm.token) {
          return CommonModel.getQiniuUptoken().then(res => {
            this.qiniuHost = res.qiniuHost
            this.uploadForm.token = res.uptoken
            let curr = date(new Date().getTime(), 'yyyyMMdd')
            let prefix = 'brand'
            let suffix = file.name
            this.uploadForm.key = encodeURI(`${curr}/${prefix}_${suffix}`)
            console.log(this.uploadForm)
          })
        } else {
          let curr = date(new Date().getTime(), 'yyyyMMdd')
          let prefix = 'brand'
          let suffix = file.name
          this.uploadForm.key = encodeURI(`${curr}/${prefix}_${suffix}`)
          console.log(this.uploadForm)
        }
        return true
      },
      //
      pageSizeChange (size) {
        this.pageSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.pageSize,
          keywords: this.keywords,
          type: this.type,
          categoryId: this.categoryId
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        QuestionModel.find(_opts).then(res => {
          this.tableData = res.item_list
          this.total = res.total
        })
      },
      //
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            QuestionModel.delete({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      initNewHandle () {
        this.curObj = {
          id: '',
          name: '',
          image: ''
        }
        this.isObjShow = true
      },
      newHandle () {
        QuestionModel.create({
          name: this.curObj.name,
          image: this.curObj.image,

        }).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditHandle (item) {
        this.$router.push({
          name: 'question.new',
          query: { id: item.row.id }
        })
      },
      editHandle () {
        QuestionModel.update({
          id: this.curObj.id,
          name: this.curObj.name,
          image: this.curObj.image,
        }).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      searchHandle () {
        this.getObjList()
      },
      downloadHandle (item) {
        this.$router.push({
          name: 'question.qrcode',
          query: {redEnvelopeId: item.row.id, type: 2}
        })
      },
      dateChange (value) {
        if (value) {
          this.startDate = value[0]
          this.endDate = value[1]
        } else {
          this.startDate = ''
          this.endDate = ''
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 10px
        margin-bottom: 10px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
      .check-title
        text-align: right
        display: inline-block
        vertical-align: middle
        width: 90px
        font-size: 14px
        color: #48576a
        line-height: 1
        padding: 11px 12px 11px 0
        box-sizing: border-box
      .avatar-uploader
          border: 1px dashed #d9d9d9
          border-radius: 6px
          cursor: pointer
          position: relative
          overflow: hidden
          width: 180px
          &:hover
            border-color: #409EFF
          .avatar-uploader-icon
            font-size: 28px
            color: #8c939d
            width: 178px
            height: 178px
            line-height: 178px
            text-align: center
          .avatar
            width: 178px
            height: 178px
            display: block
</style>



// WEBPACK FOOTER //
// src/views/Question.vue